import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const CATEGORY_COLORS = {
  medecine_generale: { bg: 'bg-[hsl(205,85%,45%)]', text: 'text-white', label: 'Médecine générale' },
  specialites: { bg: 'bg-[hsl(340,82%,55%)]', text: 'text-white', label: 'Spécialités médicales' },
  neuro_psy_pedia: { bg: 'bg-[hsl(270,58%,55%)]', text: 'text-white', label: 'Neuro/psy/pédiatrie' },
  sciences_fondamentales: { bg: 'bg-[hsl(152,55%,40%)]', text: 'text-white', label: 'Sciences fondamentales' },
  organisation_sante_publique: { bg: 'bg-[hsl(25,92%,55%)]', text: 'text-white', label: 'Organisation & santé publique' },
};

export const ROLE_LABELS = {
  auteur: 'Auteur',
  moderateur: 'Modérateur',
  curateur: 'Curateur',
  analyste: 'Analyste',
  synthetiseur: 'Synthétiseur',
  debatteur: 'Débatteur',
  fact_checker: 'Fact-checker',
  pedagogue: 'Pédagogue',
  chercheur: 'Chercheur',
  vulgarisateur: 'Vulgarisateur',
  expert_clinique: 'Expert clinique',
  veilleur: 'Veilleur',
};

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diff = (now - date) / 1000;

  if (diff < 60) return 'à l\'instant';
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `il y a ${Math.floor(diff / 86400)}j`;
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
}

export function formatNumber(num) {
  if (!num && num !== 0) return '0';
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}k`;
  return num.toString();
}

export function getCategoryColor(categoryKey) {
  return CATEGORY_COLORS[categoryKey] || CATEGORY_COLORS.medecine_generale;
}
